var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"topHeader",on:{"click":_vm.toserch}},[_c('div',[_c('md-icon',{staticStyle:{"margin-right":"0.1rem","color":"#ffffff"},attrs:{"name":"search"}}),_c('span',[_vm._v(_vm._s(_vm.message))])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }